var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"StyledErrorBanner-sc fsValidationError",attrs:{"role":"alert"}},[_c('div',{staticClass:"StyledErrorBannerText-sc FieldInlineError__StyledErrorBannerText-sc"},[_c('div',{staticClass:"StyledErrorBannerIcon-sc"}),_c('div',[_vm._v(_vm._s(_vm.errMsg))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }